import { createAdditionalParams, invokeApi, get } from '.';

export const getInstrumentInfo = async ({ serviceId, instrumentInfoId }) => {
  const additionalParams = await createAdditionalParams();
  return invokeApi({}, `${serviceId}/instrument_info?id=${encodeURI(instrumentInfoId)}`, get, additionalParams);
};
